import { Component, Vue } from 'vue-property-decorator';
import { ITABLECOLCONF } from '@/types/base.d';
import api from '@/api/course';

@Component
export default class tableMixin extends Vue {
  private cList: any = [];

  public chapterId: string = '';

  private column: Array<ITABLECOLCONF> = [{
    label: '知识点名称',
    prop: 'knowledgeTitle',
    align: 'center',
    width: '200px',
    tooltip: true,
  },
  {
    label: '排序',
    prop: 'knowledgeSort',
    align: 'center',
    width: '60px',
  }, {
    label: '难易程度',
    prop: 'iconPath',
    custom: true,
    icon: true,
    align: 'center',
    width: '100px',
  }, {
    label: '创建时间',
    prop: 'createTime',
    align: 'center',
    minWidth: '100px',
    tooltip: true,
  }, {
    label: '更新时间',
    prop: 'updateTime',
    align: 'center',
    minWidth: '100px',
    tooltip: true,
  }, {
    label: '操作',
    custom: true,
    minWidth: '120',
    align: 'center',
    maxBtn: 1,
    btnList: [
      {
        title: '修改',
        name: '/course/chapter/knowledge:update',
        icon: 'edit',
        type: 'info',
        callback: this.handleEdit,
        log: {
          name: '视频 - 修改',
          component: '/course/chapter/knowledge:update',
        },
      },
      {
        title: '删除',
        name: '/course/chapter/knowledge:remove',
        icon: 'trash-o',
        type: 'info',
        callback: this.handleRemove,
        log: {
          name: '视频 - 删除',
          component: '/course/chapter/knowledge:remove',
        },
      },
    ],
  }]

  private loading: boolean = false;

  getData(pid: string) {
    return new Promise((resolve, reject) => {
      api.getKnowedge(pid).then((res: any) => {
        this.cList = res;
        this.chapterId = pid;
        resolve(res);
      });
    });
  }

  /* eslint-disable class-methods-use-this */
  handleEdit(row: any) {}

  handleOperate(row: any) {}

  /**
   * @author liangyongmou
   * @desc 删除正式课事件
   * @params { any } row 行数据
   */
  handleRemove(row: any) {
    this.confirm('你确定要删除该知识点吗?', {
      title: '警告',
      loading: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      iconType: 'warning',
    }).then((close: Function) => {
      api.removeKnowedge(row.pid).then(() => {
        this.getData(this.chapterId);
        close();
        this.$log({
          title: '正式课管理 - 知识点 - 确定',
          component: 'course/chapter/rescource',
        });
      }).catch(() => close());
    }).catch(() => this.$log({
      title: '正式课管理 - 知识点 - 取消',
      component: 'course/chapter/rescource',
    }));
  }
}
